// 自动生成文件 切勿改动!

export const projectName = 'app-self-support-order'
export const dvaNamespacePrefix = 'appSelfSupportOrder'
